var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-body',[_c('div',{staticClass:"row"},_vm._l((_vm.widget),function(item){return _c('div',{key:item.alias,staticClass:"col-md-6"},[_c('EditorNumber',{attrs:{"item":_vm.field(item.alias),"entity":_vm.entity,"scope":"module","validate":false}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }